import { render, staticRenderFns } from "./customCollapse.vue?vue&type=template&id=32b56393&scoped=true&"
import script from "./customCollapse.vue?vue&type=script&lang=js&"
export * from "./customCollapse.vue?vue&type=script&lang=js&"
import style0 from "./customCollapse.vue?vue&type=style&index=0&id=32b56393&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b56393",
  null
  
)

export default component.exports